exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button_from_CircleButton-css_3Jf {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n}\n", ""]);

// exports
exports.locals = {
	"button": "button_from_CircleButton-css_3Jf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/components/action/CircleButton.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/CircleButton.css
// module chunks = 0